import { useTransition, config } from "react-spring";
export var useBlurAnimation = function useBlurAnimation(r) {
  return useTransition(r, {
    from: {
      backdropFilter: "blur(0px)",
      WebkitBackdropFilter: "blur(0px)",
      background: "rgba(255, 255, 255, 0)"
    },
    enter: {
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      background: "rgba(255, 255, 255, 0.62)"
    },
    leave: {
      backdropFilter: "blur(0px)",
      WebkitBackdropFilter: "blur(0px)",
      background: "rgba(255, 255, 255, 0)"
    }
  });
};
export var useDrawerAnimation = function useDrawerAnimation(r) {
  return useTransition(r, {
    config: Object.assign(Object.assign({}, config.default), {
      friction: 16,
      clamp: !0
    }),
    from: {
      transform: "translateX(-25%)",
      opacity: "0"
    },
    enter: {
      transform: "translateX(0%)",
      opacity: "1"
    },
    leave: {
      transform: "translateX(-25%)",
      opacity: "0"
    }
  });
};
export var useFadeTransition = function useFadeTransition(r) {
  return useTransition(r, {
    config: Object.assign(Object.assign({}, config.default), {
      friction: 16,
      clamp: !0
    }),
    from: {
      transform: "translateX(-5%)",
      opacity: "0"
    },
    enter: {
      transform: "translateX(0%)",
      opacity: "1"
    }
  });
};